export const MarketPin = ({ number, isDarkTheme = false }) => {
    const pinColor = isDarkTheme ? "#8EE4CA" : "#2E5D4B";
    const textColor = isDarkTheme ? "#14201E" : "#E9F8F3";
    return (
        <div className="relative" style={{ zIndex: `${20 - number}` }}>
            <svg width="20" height="26" viewBox="0 0 20 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="9.5" y="19.5" width="1" height="6" rx="0.5" fill={pinColor} stroke={pinColor} />
                <circle cx="10" cy="10" r="9.25" fill={pinColor} stroke={pinColor} strokeWidth="1.5" />
            </svg>
            <div
                className="absolute font-bold text-xs/[20px] left-1/2 transform -translate-x-1/2 top-0"
                style={{
                    color: textColor,
                }}
            >
                {number}
            </div>
        </div>
    );
};
